import environment from "../environment";

export const GuestCheckoutAPI = {
    braintree: (cartId: string) => `/rest/${environment().checkoutFlow}/V1/guest-carts/${cartId}/braintree/client-token`,
    estimateShippingMethod: (cartId: string) => `/rest/${environment().checkoutFlow}/V1/guest-carts/${cartId}/estimate-shipping-methods`,
    shippingInformation: (cartId: string) => `/rest/${environment().checkoutFlow}/V1/guest-carts/${cartId}/shipping-information`,
    totals: (cartId: string) => `/rest/${environment().checkoutFlow}/V1/guest-carts/${cartId}/totals`,
    applyPromoCode: (cartId: string, couponCode) => `/rest/${environment().checkoutFlow}/V1/guest-carts/${cartId}/promo-code/${couponCode}`,
    removePromoCode: (cartId: string) => `/rest/${environment().checkoutFlow}/V1/guest-carts/${cartId}/promo-code`,
    placeOrder: (cartId: string) => `/rest/${environment().checkoutFlow}/V1/guest-carts/${cartId}/payment-information`,
    orderConfirmation: (cartId: string, orderId: string) => `/rest/${environment().checkoutFlow}/V1/guest-carts/${cartId}/orders/${orderId}`
}

export function getCartIdFromURL() {
    const cartId = new URLSearchParams(window.location.search).get(CART_ID);
    if (!cartId) {
      console.error("Cart Id not present when required. Redirecting user to the home page.")
      location.href = '/';
      throw new Error();
    }
    return cartId;
  }

  export const CART_ID = "cartId";